import { AccessLevels } from '../config/access.levels';
import { Help } from 'components/Help/Help';
import { history } from 'utils/history.handler';
import { Home } from 'components/Home';
import { ListDevice } from 'components/ListDevice';
import { ListProvider } from 'components/ListProvider';
import { WorkShopList } from 'components/ListWorshop';
import { ListUser } from 'components/ListUser';
import { ListWorkshopType } from 'components/ListWorkshopType';
import { ListComisionist } from 'components/ListComisionist';
import NewComisionistPage from 'components/ListComisionist/NewComisionistPage';
import { Login } from 'components/Login';
import { PageNotFound } from 'components/PageNoFound';
import { PersistGate } from 'redux-persist/integration/react';
import { Profile } from 'components/Profile';
import { SystemParameters } from 'components/SystemParameters';
import { Provider } from 'react-redux';
import React from 'react';
import { Routes } from 'config/routes';
import { AppRoute, LoginAcces, AppRouteList } from 'components/appRoute/AppRoute';
import { karthusPersists, karthusStore } from 'redux/store';
import { Route, Router, Switch } from 'react-router-dom';
import Dashboard from 'components/Dashboard/Dashboard';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import 'index.css';

export const App = () => {
  return (
    <Provider store={karthusStore}>
      <PersistGate loading={null} persistor={karthusPersists}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          <Router history={history}>
            <Switch>
              <LoginAcces exact path={Routes.login}>
                <Login />
              </LoginAcces>
              <AppRoute exact path={Routes.home} accessLevel={AccessLevels.FinanceManager}>
                <Home />
              </AppRoute>
              <AppRouteList
                exact
                path={Routes.dashboard}
                accessLevel={[
                  AccessLevels.Coordinator,
                  AccessLevels.CommercialManager,
                  AccessLevels.HelpDesk,
                  AccessLevels.Admin,
                ]}
              >
                <Dashboard />
              </AppRouteList>

              <AppRoute exact path={'/'} accessLevel={AccessLevels.Coordinator}>
                <WorkShopList />
              </AppRoute>
              <AppRouteList
                exact
                path={Routes.workshop}
                accessLevel={[
                  AccessLevels.Coordinator,
                  AccessLevels.CommercialManager,
                  AccessLevels.Admin,
                  AccessLevels.FinanceManager,
                ]}
              >
                <WorkShopList />
              </AppRouteList>
              <AppRouteList
                exact
                path={Routes.comisionist}
                roles={['Admin', 'FinanceManager', 'CommercialManager']}
                accessLevel={[]}
              >
                <ListComisionist />
              </AppRouteList>
              <AppRouteList
                exact
                path={Routes.comisionistForm}
                accessLevel={[
                  AccessLevels.Coordinator,
                  AccessLevels.CommercialManager,
                  AccessLevels.Admin,
                  AccessLevels.FinanceManager,
                ]}
              >
                <NewComisionistPage />
              </AppRouteList>
              <AppRoute exact path={Routes.users} accessLevel={AccessLevels.CommercialManager}>
                <ListUser />
              </AppRoute>
              <AppRoute exact path={Routes.providers} accessLevel={AccessLevels.HelpDesk}>
                <ListProvider />
              </AppRoute>
              <AppRoute exact path={Routes.devices} accessLevel={AccessLevels.HelpDesk}>
                <ListDevice />
              </AppRoute>
              <AppRoute exact path={Routes.workshopTypes} accessLevel={AccessLevels.HelpDesk}>
                <ListWorkshopType />
              </AppRoute>
              <AppRouteList
                exact
                path={Routes.help}
                accessLevel={[
                  AccessLevels.Coordinator,
                  AccessLevels.CommercialManager,
                  AccessLevels.HelpDesk,
                  AccessLevels.Admin,
                  AccessLevels.FinanceManager,
                ]}
              >
                <Help />
              </AppRouteList>
              <AppRouteList
                exact
                path={Routes.profile}
                accessLevel={[
                  AccessLevels.Coordinator,
                  AccessLevels.CommercialManager,
                  AccessLevels.HelpDesk,
                  AccessLevels.Admin,
                  AccessLevels.FinanceManager,
                ]}
              >
                <Profile />
              </AppRouteList>
              <AppRoute exact path={Routes.systemParameters} accessLevel={AccessLevels.Admin}>
                <SystemParameters />
              </AppRoute>
              <Route>
                <PageNotFound />
              </Route>
            </Switch>
          </Router>
        </LocalizationProvider>
      </PersistGate>
    </Provider>
  );
};
